// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"db7014f6","64":"f4ab0d70","277":"dcd7b7c7","370":"3cb7ae83","484":"b8dfb80e","630":"17844cfb"}[chunkId] + ".chunk.js";
};